import getScene from '@cartwhl/common/api/getScene';
import type { Scene } from '@cartwhl/common/types';
import { SceneType } from '@cartwhl/common/types';

// TODO @vsa: add support for multi-character and multi-motion timeline scenes.
export function getPrimaryMotionJobIdFromScene(
  scene: Scene,
): { jobId: string; label?: string } | null {
  if (scene.type !== SceneType.MOTION || !scene.objects) {
    return null;
  }

  const objectEntries = Object.entries(scene.objects);
  if (objectEntries.length === 0) {
    return null;
  }

  const firstObject = objectEntries[0]?.[1];
  const firstTimelineItem = firstObject?.timeline?.[0];
  if (!firstTimelineItem?.appliedMotionEditJobID && !firstTimelineItem?.jobID) {
    return null;
  }

  return {
    jobId: firstTimelineItem.appliedMotionEditJobID ?? firstTimelineItem.jobID,
    label: firstTimelineItem.title?.trim() || undefined,
  };
}

export async function resolveMotionJobIdFromSceneAsset(
  apiKey: string,
  sceneID: string,
): Promise<{ jobId: string; label?: string } | null> {
  const { data, error } = await getScene(sceneID, apiKey);
  if (error || !data) {
    return null;
  }

  return getPrimaryMotionJobIdFromScene(data);
}
